import { render, staticRenderFns } from "./reportNotesModal.vue?vue&type=template&id=04c5f279&scoped=true"
import script from "./reportNotesModal.vue?vue&type=script&lang=js"
export * from "./reportNotesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c5f279",
  null
  
)

export default component.exports